import type { ApiClientV2 } from 'utils/api-client/api-client.utils'
import { FromSwagger } from 'types/helpers'
import { IdentityTokenAttributes } from 'types/__generated__/api'

const SHOP_IDENTITY_TOKENS_URL = (sellerSlug: string): string => `/shop/${sellerSlug}/identity_tokens`

type ShopIdentityTokenRequestAttributes = {
  partnerSlug: string
  sellerSlug: string
}
type ShopIdentityTokenResponse = FromSwagger<IdentityTokenAttributes>

export const createShopIdentityTokensApi = ({ POST }: ApiClientV2) => ({
  fetchIdentityToken: (data: ShopIdentityTokenRequestAttributes) =>
    POST<ShopIdentityTokenResponse>(SHOP_IDENTITY_TOKENS_URL(data.sellerSlug), data),
})

export type ShopIdentityTokensApi = ReturnType<typeof createShopIdentityTokensApi>
